import React from 'react'
import { StackLayout, Card, CardBody, CardFooter, GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { Button, ButtonGroup } from '@progress/kendo-react-buttons'

import { Window } from '@progress/kendo-react-dialogs'

import CodeNameInput from './CodeNameInput'

import './CodeName.css'

export default function CodeNameSearchResultList() {
  const [showMaintenanceDialog, setShowMaintenanceDialog] = React.useState(false)

  const toggleMaintenanceDialog = () => {
    setShowMaintenanceDialog(!showMaintenanceDialog)
  }

  return (
    <StackLayout orientation="vertical" gap={5}>
      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H1</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">型枠工</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">型枠工</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">1</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H2</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">鉄筋工</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">鉄筋工</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">2</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H3</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">鉄骨製作</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">鉄骨製作</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">3</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H4</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">耐火被覆</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">耐火被覆</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">4</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H5</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">耐火巻付</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">耐火巻付</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">5</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H6</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">PC躯体系</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">PC躯体系</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">6</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H7</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">PCCW</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">PCCW</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">7</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      <Card orientation="horizontal">
        <CardBody>
          <GridLayout>
            <GridLayoutItem row={1} col={1} style={{ width: '156px' }}>
              <span className="span-font-layout">費目</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={2} style={{ width: '56px' }}>
              <span className="span-font-layout">H8</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={3} style={{ width: '256px' }}>
              <span className="span-font-layout">ALC・ECP</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={4} style={{ width: '256px' }}>
              <span className="span-font-layout">ALC・ECP</span>
            </GridLayoutItem>
            <GridLayoutItem row={1} col={5} style={{ width: '56px' }}>
              <span className="span-font-layout">8</span>
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button themeColor="secondary" fillMode="flat" className="button-codename-search" onClick={toggleMaintenanceDialog}>
              修正
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>

      {showMaintenanceDialog && (
        <Window title={'コード名称マスタメンテナンス　編集'} onClose={toggleMaintenanceDialog} initialWidth={1366} initialHeight={650} modal>
          <CodeNameInput />
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          ></div>
        </Window>
      )}
    </StackLayout>
  )
}
